export default __webpack_public_path__ + "static/toolbar-feature-flags-light-mode-dc4f66d87268006d51051260d00e596a.mp4";